const getters = {
  token: state => state.user.token,
  info: state => state.user.info
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js